export const TRACK_WATCHTIME_INTERVAL = 10000;
export const TRACK_PROGRESS_INTERVAL = 25000;
export const FASTER_TRACK_PROGRESS_INTERVAL = 10000;
